export default {
  iAmWorker: 'Annotators', // 大标题栏
  iAmPublisher: 'Publisher', // 大标题栏
  rechargepoint: 'Recharge', // 以下 小标题栏
  mypoints: 'My Points',
  mypoints2: 'My Asset',
  newtask: 'Create new Project',
  publishtodo: 'Project unchecked',
  subNavTit1: 'To submit task',
  subNavTit2: 'Review progress',
  subNavTit3: 'Funcoins setting',
  subNavTit4: 'My task',
  subNavTit5: 'Dataset management',
  subNavTit6: 'recharge record',
  subNavTit7: 'invoices management',
  subNavTit8: 'contract management',
  subNavTit9: 'Withdrawal history',
  subNavTit10: 'Income details',
  credits: 'Credits',
  tax: 'Tax',
  js: {
    error: 'Fail',
    success: 'Success'
  },
  account: {
    overfiew: 'Total credits',
    integral: 'Available credits',
    forecastcredits: 'Pending credits',
    truebalancerecharge: 'Real remaining points',
    forecastBalancerecharge: 'Estimated remaining points',
    exchange: 'Exchange cash'
  },
  join: {
    takepart: 'Project involved',
    name: 'Name',
    typeStr: 'Type',
    taskFlagStr: 'Status',
    operate: 'Operation',
    see: 'Check'
  },
  publish: {
    taskmanage: 'Project management',
    createtask: 'Create a task',
    release: 'Publishing',
    taskandname: 'Project NO. & Name',
    number: 'ID',
    name: 'Name',
    starttime: 'Pre-release date',
    taskstate: 'Status',
    operate: 'Operate',
    alterinfo: 'Edit',
    businessinfo: 'General information',
    detailinfo: 'Detailed information',
    offer: 'Price',
    example: 'Sample',
    course: 'Guideline',
    audit: 'Submit',
    publish: 'Publish',
    puslished: 'Published',
    releasetime: 'Publish date',
    total: 'Total',
    finished: 'Finished',
    unfinished: 'Unfinished',
    js: {
      error: {
        type1: 'Warning',
        type2: 'Cancellation'
      },
      success: {
        type1: 'Confirm',
        type2: 'Submit success',
        type3: 'Publish success',
        type4: 'Delete success'
      },
      reviewing: 'Verifying',
      pushReview: 'You cannot modify the information after submission. Do you want to continue?',
      delTask: 'This task will permanently delete. Do you want to continue?'
    }
  },
  recharge: {
    title: 'Account recharge',
    recharge: 'Recharge number:',
    rechargeremarks: 'Remarks:',
    thisRecharge: 'This recharge:',
    rechargeBtn: 'Recharge immediately',
    way: 'Pay method:',
    js: {
      rules1: 'recharge points can’t be less than 100',
      rules2: 'please enter the recharge points',
      rules3: 'recharge points must be numeric'
    }
  },
  nosubmitted: {
    nosubmitted0: 'project id',
    nosubmitted1: 'Please enter the project id',
    nosubmitted2: 'status',
    nosubmitted3: 'To submit',
    nosubmitted4: 'Reject pending modification',
    nosubmitted5: 'Inquire',
    nosubmitted6: 'Reset',
    nosubmitted7: 'Please select',
    nosubmitted8: 'project name',
    nosubmitted9: 'task id',
    nosubmitted12: 'operation',
    nosubmitted13: 'Remaining submission time',
    nosubmitted14: 'carry on',
    nosubmitted15: 'modify',
    mytaskid2: 'project status',
    mytaskid3: 'ongoing',
    mytaskid4: 'suspend',
    num: 'Number'
  },
  records: {
    transrecord: 'Transaction record',
    money: 'Price',
    time: 'Time',
    realamount: 'Actual amount',
    remarks: 'Remarks',
    taskId: 'Task Id'
  },
  withdraw: {
    integral: 'Available credits: ',
    money: 'RMB',
    note: 'Notes: 100 credits = 1.00 RMB,more than 100 points can be withdrawn',
    note1: '(Notes: 100 credits = 1.00 RMB)',
    spendPoints: 'Withdraw number',
    putforward: 'Withdraw method： ',
    alipay: 'Alipay',
    bindID: 'Binding account',
    haveInter: 'Residual coins',
    alipayaccount: 'Account',
    pleaseinput: 'Please enter',
    inter: ' credits',
    redeemnow: 'Withdrawal',
    confirminfo: 'Please confirm that the withdrawal information is correct. If there is an error, please return to the previous page to modify it.',
    amountcash: 'Cash withdrawals of this time：',
    cumulation: 'Cumulative cash withdrawals of this month',
    tax: 'Withholding taxes of this time',
    really: 'Actually received of this time',
    reset: 'Cancellation',
    confirm: 'Confirm',
    incomes: 'Individual income tax',
    message1: 'You need to bind the payment account first. Please click "bind account" below',
    exchange: 'Exchange Rate',
    cny: 'CNY',
    usd: 'USD',
    js: {
      rules: {
        account: 'Please associate account',
        name1: 'Please enter your real name',
        name2: 'The name you entered does not match the name of the ID card',
        spendPoints1: 'Withdrawal points can’t be less than 100 and can’t exceed the withdrawable points',
        spendPoints2: 'Please enter the number of points that need to be withdrawn',
        spendPoints3: 'Please enter the number'
      }
    }
  },
  receipt: {
    prompt1: 'If the invoice amount exceeds 500 RMB, the Express Fee will be exempted',
    toInvoice: 'Apply for invoicing',
    created: 'Time',
    title: 'Invoice title',
    type1: 'Type',
    type2: 'Plain invoice',
    type3: 'Special invoice',
    step1: 'Status',
    step2: 'Have completed',
    step3: 'Have applied'
  },
  invoice: {
    amount: 'Invoice amount',
    invoiceinfo: 'Billing information',
    invoicetypt: 'Types of invoice title',
    person: 'Individual',
    company: 'Corporation',
    personName: 'Personal name',
    companyName: 'Corporate name',
    govcode: 'Taxpayer ID',
    add: 'and',
    bank: 'Bank',
    bankaccount: 'bank account',
    addressphone: 'Address and phone number',
    corpaddress: 'Corporate address',
    corpphone: 'Corporate phone number',
    invoiceCon: 'Content of the invoice',
    services: 'Technical services',
    taxRate: 'Tax rate',
    sendinfo: 'Consignee’s information',
    sendname: 'Consignee’s name',
    sendphone: 'Phone number',
    sendaddress: 'Consignee’s address',
    checkInvoice: 'Confirm application',
    js: {
      amount1: 'Please enter the invoice amount',
      amount2: 'The amount of cash withdrawal must be numeric',
      invoicetypt: 'Please select the types of invoice title',
      type: 'Please select the types of invoice',
      title: 'Please fill in the invoice title',
      govcode: 'Please enter the taxpayer identification number',
      sendname: 'Please enter the consignee’s name',
      sendphone: 'Please enter the phone number',
      sendaddress: 'Please enter the consignee’s address'
    }
  },
  limitMgr: {
    limitMgr: 'Permission',
    usernameNote: 'Please enter user name or user name prefix (do not support blank, line feed).',
    limit: 'Authority',
    please: 'Please choose authority',
    nolimit: 'Don’t have authority',
    taskdo: 'Start the task',
    check: 'Check',
    update: 'Update ',
    return: 'Back',
    reports: 'reports',
    js: {
      rule: {
        username: 'Please enter user name or user name prefix (do not support blank, line feed).',
        puflag: 'Please choose authority'
      },
      success: 'Save success '
    }
  },
  income: {
    str1: 'Bill',
    str2: 'Daily bill',
    str3: 'Today',
    str4: 'This week',
    str5: 'This month',
    str6: 'Start date',
    str7: 'End date',
    str8: 'Funcions',
    str9: 'Task Funcoins',
    str10: 'Funcions issued by administrator',
    str11: 'Funcions of skill test',
    str12: 'Funcoins of Trade union ',
    str13: 'Check',
    str14: 'Date',
    str15: 'Serial number',
    str16: 'Type',
    str17: 'Remarks',
    see: 'Check',
    reset: 'Reset',
    to: 'To',
    date: 'Date',
    operation: 'Operation'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en/workbench.js